import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import './AdminGearIcon.css';

const AdminGearIcon = () => {
  const { userProfile } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Only show for admin users and not on the admin page itself
  const isAdmin = userProfile?.name?.toLowerCase() === 'admin';
  const isOnAdminPage = location.pathname === '/admin';

  if (!isAdmin || isOnAdminPage) {
    return null;
  }

  return (
    <motion.button
      className="admin-gear-icon"
      onClick={() => navigate('/admin')}
      whileHover={{ scale: 1.1, rotate: 90 }}
      whileTap={{ scale: 0.9 }}
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3 }}
      title="Admin Settings"
    >
      ⚙️
    </motion.button>
  );
};

export default AdminGearIcon;
